import React from 'react'
import { Modal } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import 'style/modals/NoteModal.css'

class NoteModal extends React.Component {
    state = {
        open: false
    }

    openModal = () => this.setState({ open: true })

    closeModal = () => this.setState({ open: false })

    render() {
        return (
            <Modal
                open={this.state.open}
                onClose={this.closeModal}
                className="modal-alert"
            >
                <div className="note-modal">
                    <div className="note-modal__header">
                        <CloseIcon onClick={this.closeModal} />
                    </div>
                    <div className="note-modal__box">
                        <p>{this.props.message}</p>
                    </div>
                    <div className="note-modal__button-container">
                        <button onClick={this.closeModal}>متوجه شدم!</button>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default NoteModal